import { useRef } from 'react'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import moment from 'moment'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { ActivationCenter as ActivationCenterComponent } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter'
import { useAvailabilities } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/Availabilities'
import { usePermissionsData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/PermissionsProvider'

import { useMissingAgreementData } from '../../../hooks/useMissingAgreementData'
import { agreementsResources } from './Sources/agreements'
import { expenseResources } from './Sources/expenses'
import { payrollResources } from './Sources/payroll'
import { projectsResources } from './Sources/projects'

export const ActivationCenter = () => {
  const [fwEmployeeCostActivationCenterSeen, setFwEmployeeCostActivationCenterSeen] =
    useLocalStorage(LOCAL_STORAGE_KEYS.fwEmployeeCostActivationCenterSeen)
  const defaultOpen = useRef(false)

  const { availabilities, loading: availabilitiesLoading } = useAvailabilities()
  const { permissions } = usePermissionsData()

  const agreementsData = useMissingAgreementData({
    variables: {
      formattedStartDate: moment('1970-01-01').format('YYYY-MM-DD'),
      formattedEndDate: moment().format('YYYY-MM-DD'),
      period: 'monthly',
    },
  })

  const agreementsResource = agreementsResources(agreementsData)
  const expensesResource = expenseResources(availabilities.modules.expenses)
  const projectsResource = projectsResources(availabilities.modules.projects)
  const payrollResource = payrollResources({
    availabilities,
    permissions,
  })

  const resources = [agreementsResource, payrollResource, expensesResource, projectsResource]

  useUnsafeEffect(() => {
    if (!fwEmployeeCostActivationCenterSeen) {
      setFwEmployeeCostActivationCenterSeen(true)
      defaultOpen.current = true
    }
  }, [])

  return (
    <ActivationCenterComponent
      resources={resources}
      loading={agreementsData.loading || availabilitiesLoading}
      defaultOpen={defaultOpen.current}
    />
  )
}
